import React from "react";
import {} from "reactstrap";
// import SongManager from "./SongManager";
import NnSong from "./NnSong";

class NnDisplay extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="SongPanel">
        <div className="SongGraphic">
          <img id="StageImage" src={this.props.cover} alt="song graphic" />
        </div>

        {/* This area contains the NotesTiming and Lyrics information */}
        <NnSong
          id="song-display"
          song={this.props.song}
          position={this.props.position}
        />
      </div>
    );
  }
}

export default NnDisplay;



// WEBPACK FOOTER //
// ./src/NnDisplay.js